import LocationLayout from "./LocationLayout";
import {getBookableLocations} from "../../helpers/locations";

export default function LocationOpenedLayout({
                                                 location,
                                                 data,
                                                 trialSlotsResponse,
                                                 hasCookiePreferences,
                                                 cookiePreferences
                                             }) {

    return (
        <LocationLayout location={location}
                        data={data}
                        showIntro={true}
                        showFullscreen={false}
                        showConcepts={true}
                        showTrainers={false}
                        showMap={false}
                        showScheduleTrial={getBookableLocations().includes(location)}
                        showFeatures={true}
                        showPhone={false}
                        hasCookiePreferences={hasCookiePreferences}
                        cookiePreferences={cookiePreferences}
                        trialSlotsResponse={trialSlotsResponse}
        />
    )
}